import axios from "axios";

export default {
  axios: axios,
  baseUrl: () => {
    let url = window.location.protocol + "//" + window.location.hostname;
    url += window.location.host !== window.location.hostname ? ":21128" : "";
    return url.replace(/([^:]\/)\/+/g, "$1");
  },
  plazaUrl: "https://plaza.quickbe.app/",

  validateToken: function(headers, store) {
    if (headers["validate-token"] !== undefined) {
      store.commit("setToken", headers["validate-token"]);
    }
  },
  checkAuth: function(error, store, router) {
    if (error.response.status === 401 || error.response.status === 403) {
      if (error.response.status === 401) {
        store.commit("resetToken");
        router.push(
          "/admin/login?msg=" +
            store.state.currentTranslator.getString(
              "Sessione scaduta, effettua di nuovo il login"
            )
        );
      }
      if (error.response.status === 403)
        router.push(
          "/admin/dashboard?msg=" +
            store.state.currentTranslator.getString(
              "Non hai il permesso per accedere a questa risorsa"
            )
        );
      return true;
    } else {
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/ajax.js